import { render, staticRenderFns } from "./401.vue?vue&type=template&id=6b10a48b&scoped=true"
import script from "./401.vue?vue&type=script&lang=js"
export * from "./401.vue?vue&type=script&lang=js"
import style0 from "./401.vue?vue&type=style&index=0&id=6b10a48b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b10a48b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b10a48b')) {
      api.createRecord('6b10a48b', component.options)
    } else {
      api.reload('6b10a48b', component.options)
    }
    module.hot.accept("./401.vue?vue&type=template&id=6b10a48b&scoped=true", function () {
      api.rerender('6b10a48b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/401.vue"
export default component.exports